document.addEventListener("DOMContentLoaded", function () {
    const body = document.body;
    let activeModal = null;

    function toggleModal(modal, show) {
        if (!modal) return;

        if (show) {
            closeActiveModal();
            modal.classList.add("is-visible");
            body.classList.add("overflow-hidden");
            activeModal = modal;
        } else {
            modal.classList.remove("is-visible");
            body.classList.remove("overflow-hidden");
            activeModal = null;
        }
    }

    function closeActiveModal() {
        if (activeModal) {
            toggleModal(activeModal, false);
        }
    }

    const triggers = document.querySelectorAll(".js-modal-trigger");
    triggers.forEach(trigger => {
        const targetSelector = trigger.getAttribute("data-target");
        const modal = document.querySelector(targetSelector);

        if (modal) {
            trigger.addEventListener("click", function (event) {
                event.stopPropagation();
                toggleModal(modal, true);
            });
        }
    });

    const modals = document.querySelectorAll(".js-modal");
    modals.forEach(modal => {
        const closeBtn = modal.querySelector(".js-close-btn");

        if (closeBtn) {
            closeBtn.addEventListener("click", function (event) {
                event.stopPropagation();
                toggleModal(modal, false);
            });
        }

        modal.addEventListener("click", function (event) {
            if (event.target === modal) {
                toggleModal(modal, false);
            }
        });
    });

    window.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
            closeActiveModal();
        }
    });
});